export default __webpack_public_path__ + "static/media/5.8a050c71.png";